import Vue from 'vue';
import accountService from '../account';
import store from '../../store';

/**
 * When the request succeeds
 */
const success = (response, resolve) => {
  const token = localStorage.id_token_saved;
  store.dispatch('login', token);
  accountService.find().then(() => {
    Vue.router.push({
      name: 'dashboard',
    });
    resolve();
  });
};

/**
 * When the request fails
 */
const failed = (error, reject) => {
  if (error.response.statusText === 'Unauthorized') {
    return reject({ errors: ['Invalid Code'] });
  }
  return reject(error.response.data);
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/auth/${data.user_id}/verify_sms_2fa_code`, data)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/auth/verifySmsTwoFactorCode.js